export const mentionRegExp = /(?:(^|[^a-zA-Z0-9_＠!@#$%&*]))((?:[@＠](?!\/))[a-z0-9/_.-]{1,50})(?:\b(?![@＠])|$)/;

export const stringToColour = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }
  const color = (hash & 0x00ffffff).toString(16).toUpperCase();
  return "#" + "000000".substring(0, 6 - color.length) + color;
};

export const removeLastCharacterPolyfill = (str: string) => {
  const emojiRegex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\p{Extended_Pictographic}|\p{Emoji})\uFE0F?/gu;
  const matches = [...str.matchAll(emojiRegex)];
  if (matches.length > 0) {
    return str.slice(0, matches[matches.length - 1].index);
  }
  return str.slice(0, [...str].length - 1);
};

export const removeLastCharacter = (str: string) => {
  if ("Segmenter" in Intl) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const segmenter = new Intl.Segmenter("en", { granularity: "grapheme" });
    const segments = [...segmenter.segment(str)].map(seg => seg.segment);
    segments.pop();
    return segments.join("");
  } else {
    return removeLastCharacterPolyfill(str);
  }
};
